export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
};

export type AlleleStat = {
  __typename?: 'AlleleStat';
  allele_count?: Maybe<Scalars['Int']>;
  allele_frequency?: Maybe<Scalars['Float']>;
  allele_number?: Maybe<Scalars['Int']>;
  homozygote_count?: Maybe<Scalars['Int']>;
};

export enum AnnotatorName {
  Nirvana = 'nirvana',
  Vep = 'vep'
}

export type BoolFilter = {
  __typename?: 'BoolFilter';
  name: Scalars['String'];
  value: Scalars['Boolean'];
};

export type BoolFilterInput = {
  name: Scalars['String'];
  value: Scalars['Boolean'];
};

export type Coverage = {
  __typename?: 'Coverage';
  mean?: Maybe<Scalars['Float']>;
  pos?: Maybe<Scalars['Int']>;
};

export type DatabaseInfo = {
  __typename?: 'DatabaseInfo';
  created_date?: Maybe<Scalars['String']>;
  database_id?: Maybe<Scalars['ID']>;
  database_name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  filter_options?: Maybe<DatasetFilterOptions>;
  num_of_samples?: Maybe<Scalars['Int']>;
  public?: Maybe<Scalars['Boolean']>;
  reference_genome?: Maybe<Scalars['String']>;
  variant_count?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['String']>;
};

export type DatasetFilter = {
  __typename?: 'DatasetFilter';
  sample_filter?: Maybe<SampleFilter>;
  variant_filter?: Maybe<VariantFilter>;
};

export type DatasetFilterInput = {
  sample_filter?: InputMaybe<SampleFilterInput>;
  variant_filter?: InputMaybe<VariantFilterInput>;
};

export type DatasetFilterOptions = {
  __typename?: 'DatasetFilterOptions';
  pheno_filter_options: PhenoFilterOptions;
  variant_format_filter_options: VariantFormatFilterOptions;
  variant_frequencies_filter_options: VariantFrequenciesFilterOptions;
  variant_info_filter_options: VariantInfoFilterOptions;
};

export type DatasetInfo = {
  __typename?: 'DatasetInfo';
  created_date?: Maybe<Scalars['String']>;
  dataset_id: Scalars['String'];
  dataset_name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  filter_applied?: Maybe<DatasetFilter>;
  gene_count?: Maybe<Scalars['Int']>;
  num_of_samples?: Maybe<Scalars['Int']>;
  num_of_samples_xx?: Maybe<Scalars['Int']>;
  num_of_samples_xy?: Maybe<Scalars['Int']>;
  parent_database_id: Scalars['String'];
  public?: Maybe<Scalars['Boolean']>;
  reference_genome?: Maybe<Scalars['String']>;
  transcript_count?: Maybe<Scalars['Int']>;
  variant_count?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['String']>;
};

export type Filter = {
  __typename?: 'Filter';
  bool_filters: Array<BoolFilter>;
  num_filters: Array<NumFilter>;
  string_filters: Array<StringFilter>;
};

export type FilterInput = {
  bool_filters: Array<BoolFilterInput>;
  num_filters: Array<NumFilterInput>;
  string_filters: Array<StringFilterInput>;
};

export type Gene = {
  __typename?: 'Gene';
  canonical_transcript_id?: Maybe<Scalars['String']>;
  chrom: Scalars['String'];
  coverage_exome?: Maybe<Array<Maybe<Coverage>>>;
  coverage_genome?: Maybe<Array<Maybe<Coverage>>>;
  gene_id: Scalars['String'];
  gene_symbol?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  start: Scalars['Int'];
  stop: Scalars['Int'];
  transcript_ids?: Maybe<Array<Maybe<Scalars['String']>>>;
  variants?: Maybe<Array<Maybe<Variant>>>;
};

export type GeneQueryResult = {
  __typename?: 'GeneQueryResult';
  gene_id: Scalars['String'];
  gene_symbol?: Maybe<Scalars['String']>;
};

export type Histogram = {
  __typename?: 'Histogram';
  bin_edges?: Maybe<Array<Maybe<Scalars['String']>>>;
  bin_freq?: Maybe<Array<Maybe<Scalars['Float']>>>;
};

export type InfoBoolFilterOptions = {
  __typename?: 'InfoBoolFilterOptions';
  fraction_non_missing: Scalars['Float'];
  name: Scalars['String'];
};

export type InfoNumFilterOptions = {
  __typename?: 'InfoNumFilterOptions';
  fraction_non_missing: Scalars['Float'];
  max_value: Scalars['Float'];
  min_value: Scalars['Float'];
  name: Scalars['String'];
};

export type InfoStringFilterOptions = {
  __typename?: 'InfoStringFilterOptions';
  distinct_values: Array<Maybe<Scalars['String']>>;
  fraction_non_missing: Scalars['Float'];
  name: Scalars['String'];
};

export enum JobState {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Running = 'RUNNING'
}

export type Mutation = {
  __typename?: 'Mutation';
  cancelPendingJob?: Maybe<Scalars['Boolean']>;
  deleteDataset?: Maybe<Scalars['Boolean']>;
  setDatasetPrivate?: Maybe<DatasetInfo>;
  setDatasetPublic?: Maybe<DatasetInfo>;
  submitNewDatabase?: Maybe<Scalars['Boolean']>;
  submitNewDataset?: Maybe<Scalars['Boolean']>;
};


export type MutationCancelPendingJobArgs = {
  job_id: Scalars['String'];
};


export type MutationDeleteDatasetArgs = {
  dataset_id: Scalars['String'];
};


export type MutationSetDatasetPrivateArgs = {
  dataset_id: Scalars['String'];
};


export type MutationSetDatasetPublicArgs = {
  dataset_id: Scalars['String'];
};


export type MutationSubmitNewDatabaseArgs = {
  annotator_name: Scalars['String'];
  database_version: Scalars['String'];
  description: Scalars['String'];
  donors_info_csv_path: Scalars['String'];
  excluded_pheno_filter_fields: Array<Scalars['String']>;
  exome_str: Scalars['String'];
  female_str: Scalars['String'];
  genome_str: Scalars['String'];
  gvcf_file_extension: Scalars['String'];
  gvcf_folder_path: Scalars['String'];
  male_str: Scalars['String'];
  name: Scalars['String'];
  ref_genome: Scalars['String'];
};


export type MutationSubmitNewDatasetArgs = {
  dataset_filter: DatasetFilterInput;
  dataset_name: Scalars['String'];
  dataset_version: Scalars['String'];
  description: Scalars['String'];
  parent_database_id: Scalars['String'];
};

export type NumFilter = {
  __typename?: 'NumFilter';
  greater_or_equal_than?: Maybe<Scalars['Float']>;
  lower_or_equal_than?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
};

export type NumFilterInput = {
  greater_or_equal_than?: InputMaybe<Scalars['Float']>;
  lower_or_equal_than?: InputMaybe<Scalars['Float']>;
  name: Scalars['String'];
};

export type PhenoBoolFilterOptions = {
  __typename?: 'PhenoBoolFilterOptions';
  fraction_non_missing: Scalars['Float'];
  name: Scalars['String'];
};

export type PhenoFilterOptions = {
  __typename?: 'PhenoFilterOptions';
  bool_filters: Array<PhenoBoolFilterOptions>;
  num_filters: Array<PhenoNumFilterOptions>;
  string_filters: Array<PhenoStringFilterOptions>;
};

export type PhenoNumFilterOptions = {
  __typename?: 'PhenoNumFilterOptions';
  fraction_non_missing: Scalars['Float'];
  max_value: Scalars['Float'];
  min_value: Scalars['Float'];
  name: Scalars['String'];
};

export type PhenoStringFilterOptions = {
  __typename?: 'PhenoStringFilterOptions';
  distinct_values: Array<Maybe<Scalars['String']>>;
  fraction_non_missing: Scalars['Float'];
  name: Scalars['String'];
};

export type Population = {
  __typename?: 'Population';
  allele_stats?: Maybe<AlleleStat>;
  population_subtype?: Maybe<Scalars['String']>;
  variant_id?: Maybe<Scalars['String']>;
};

export type PopulationFrequencies = {
  __typename?: 'PopulationFrequencies';
  population_source?: Maybe<PopulationSourceType>;
  populations?: Maybe<Array<Maybe<Population>>>;
  source?: Maybe<SourceType>;
  variant_id?: Maybe<Scalars['String']>;
};

export enum PopulationSourceType {
  FrequenciesExomeAlleleStats = 'frequencies_exome_allele_stats',
  FrequenciesGenomeAlleleStats = 'frequencies_genome_allele_stats',
  FrequenciesGnomad = 'frequencies_gnomad',
  FrequenciesGnomadExom = 'frequencies_gnomad_exom',
  FrequenciesOneKg = 'frequencies_oneKg'
}

export type Query = {
  __typename?: 'Query';
  allowedAnnotatorsForDatabaseJob?: Maybe<Array<Maybe<AnnotatorName>>>;
  allowedReferenceGenomesForDatabaseJob?: Maybe<Array<Maybe<ReferenceGenome>>>;
  databaseList: Array<DatabaseInfo>;
  dataset?: Maybe<DatasetInfo>;
  datasetList: Array<DatasetInfo>;
  filterOptions: DatasetFilterOptions;
  gene?: Maybe<Gene>;
  region?: Maybe<Region>;
  regionCount?: Maybe<Scalars['Int']>;
  remainingSampleCount: Scalars['Int'];
  remainingSamples: Array<Maybe<Scalars['String']>>;
  searchSuggestions?: Maybe<SearchSuggestions>;
  transcript?: Maybe<Transcript>;
  variant?: Maybe<VariantDetails>;
  variantDatabaseJobList: Array<VariantDatabaseJob>;
  variantDatasetJobList: Array<VariantDatasetJob>;
};


export type QueryDatasetArgs = {
  dataset_id?: InputMaybe<Scalars['String']>;
};


export type QueryFilterOptionsArgs = {
  database_id: Scalars['String'];
};


export type QueryGeneArgs = {
  dataset_id: Scalars['String'];
  gene_id?: InputMaybe<Scalars['String']>;
  gene_symbol?: InputMaybe<Scalars['String']>;
};


export type QueryRegionArgs = {
  chrom: Scalars['String'];
  dataset_id: Scalars['String'];
  start: Scalars['Int'];
  stop: Scalars['Int'];
};


export type QueryRegionCountArgs = {
  chrom: Scalars['String'];
  dataset_id: Scalars['String'];
  start: Scalars['Int'];
  stop: Scalars['Int'];
};


export type QueryRemainingSampleCountArgs = {
  database_id: Scalars['String'];
  filter: DatasetFilterInput;
};


export type QueryRemainingSamplesArgs = {
  database_id: Scalars['String'];
  filter: DatasetFilterInput;
};


export type QuerySearchSuggestionsArgs = {
  dataset_id: Scalars['String'];
  query: Scalars['String'];
};


export type QueryTranscriptArgs = {
  dataset_id: Scalars['String'];
  transcript_id: Scalars['String'];
};


export type QueryVariantArgs = {
  dataset_id: Scalars['String'];
  variant_id: Scalars['String'];
};

export enum ReferenceGenome {
  GrCh37 = 'GRCh37',
  GrCh38 = 'GRCh38'
}

export type Region = {
  __typename?: 'Region';
  chrom: Scalars['String'];
  coverage_exome?: Maybe<Array<Maybe<Coverage>>>;
  coverage_genome?: Maybe<Array<Maybe<Coverage>>>;
  gene_ids?: Maybe<Array<Maybe<Scalars['String']>>>;
  gene_symbols?: Maybe<Array<Maybe<Scalars['String']>>>;
  start: Scalars['Int'];
  stop: Scalars['Int'];
  variants?: Maybe<Array<Maybe<Variant>>>;
};

export type SampleFilter = {
  __typename?: 'SampleFilter';
  pheno_filter?: Maybe<Filter>;
};

export type SampleFilterInput = {
  pheno_filter?: InputMaybe<FilterInput>;
};

export type SearchSuggestions = {
  __typename?: 'SearchSuggestions';
  gene_ids: Array<Scalars['String']>;
  gene_symbols: Array<Scalars['String']>;
  transcript_ids: Array<Scalars['String']>;
  variant_ids: Array<Scalars['String']>;
};

export enum SourceType {
  Exome = 'exome',
  Genome = 'genome'
}

export type StringFilter = {
  __typename?: 'StringFilter';
  name: Scalars['String'];
  values: Array<Scalars['String']>;
};

export type StringFilterInput = {
  name: Scalars['String'];
  values: Array<Scalars['String']>;
};

export type Transcript = {
  __typename?: 'Transcript';
  chrom: Scalars['String'];
  coverage_exome?: Maybe<Array<Maybe<Coverage>>>;
  coverage_genome?: Maybe<Array<Maybe<Coverage>>>;
  gene_id?: Maybe<Scalars['String']>;
  gene_symbol?: Maybe<Scalars['String']>;
  start: Scalars['Int'];
  stop: Scalars['Int'];
  transcript_id: Scalars['String'];
  variants?: Maybe<Array<Maybe<Variant>>>;
};

export type TranscriptConsequence = {
  __typename?: 'TranscriptConsequence';
  consequence?: Maybe<Array<Maybe<Scalars['String']>>>;
  gene_id: Scalars['String'];
  gene_symbol?: Maybe<Scalars['String']>;
  hgvsc?: Maybe<Scalars['String']>;
  hgvsp?: Maybe<Scalars['String']>;
  is_canonical?: Maybe<Scalars['Boolean']>;
  transcript_id: Scalars['String'];
};

export type Variant = {
  __typename?: 'Variant';
  alt: Scalars['String'];
  chrom: Scalars['String'];
  clinical_significance?: Maybe<Array<Maybe<Scalars['String']>>>;
  czechgenome_genome_frequencies?: Maybe<Array<Maybe<Population>>>;
  gene_ids?: Maybe<Array<Maybe<Scalars['String']>>>;
  gene_symbols?: Maybe<Array<Maybe<Scalars['String']>>>;
  length?: Maybe<Scalars['Int']>;
  pos: Scalars['Int'];
  ref: Scalars['String'];
  rsids?: Maybe<Array<Maybe<Scalars['String']>>>;
  source?: Maybe<Array<Maybe<SourceType>>>;
  transcript_consequence_major?: Maybe<TranscriptConsequence>;
  transcript_id_canonical?: Maybe<Array<Maybe<Scalars['String']>>>;
  variant_id: Scalars['String'];
};

export type VariantDatabaseJob = {
  __typename?: 'VariantDatabaseJob';
  database_description: Scalars['String'];
  database_id: Scalars['String'];
  database_name: Scalars['String'];
  end_date?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  start_date?: Maybe<Scalars['String']>;
  state: JobState;
  submitted_date: Scalars['String'];
};

export type VariantDatasetJob = {
  __typename?: 'VariantDatasetJob';
  dataset_description: Scalars['String'];
  dataset_id?: Maybe<Scalars['String']>;
  dataset_name: Scalars['String'];
  end_date?: Maybe<Scalars['String']>;
  filter_applied?: Maybe<DatasetFilter>;
  id: Scalars['String'];
  num_of_samples: Scalars['Int'];
  parent_database_id: Scalars['String'];
  start_date?: Maybe<Scalars['String']>;
  state: JobState;
  submitted_date: Scalars['String'];
};

export type VariantDetails = {
  __typename?: 'VariantDetails';
  age_distribution_exome?: Maybe<Histogram>;
  age_distribution_genome?: Maybe<Histogram>;
  alt: Scalars['String'];
  chrom: Scalars['String'];
  clinical_significance?: Maybe<Array<Maybe<Scalars['String']>>>;
  coverage_exome?: Maybe<Coverage>;
  coverage_genome?: Maybe<Coverage>;
  gene_ids?: Maybe<Array<Maybe<Scalars['String']>>>;
  gene_symbols?: Maybe<Array<Maybe<Scalars['String']>>>;
  length?: Maybe<Scalars['Int']>;
  population_frequencies?: Maybe<Array<Maybe<PopulationFrequencies>>>;
  pos: Scalars['Int'];
  ref: Scalars['String'];
  rsids?: Maybe<Array<Maybe<Scalars['String']>>>;
  source?: Maybe<Array<Maybe<SourceType>>>;
  transcript_consequence?: Maybe<Array<Maybe<TranscriptConsequence>>>;
  transcript_consequence_major?: Maybe<TranscriptConsequence>;
  variant_id: Scalars['String'];
};

export type VariantFilter = {
  __typename?: 'VariantFilter';
  variant_format_filter?: Maybe<Filter>;
  variant_frequencies_filter?: Maybe<Filter>;
  variant_info_filter?: Maybe<Filter>;
};

export type VariantFilterInput = {
  variant_format_filter?: InputMaybe<FilterInput>;
  variant_frequencies_filter?: InputMaybe<FilterInput>;
  variant_info_filter?: InputMaybe<FilterInput>;
};

export type VariantFormatFilterOptions = {
  __typename?: 'VariantFormatFilterOptions';
  bool_filters: Array<Scalars['String']>;
  num_filters: Array<Scalars['String']>;
  string_filters: Array<Scalars['String']>;
};

export type VariantFrequenciesFilterOptions = {
  __typename?: 'VariantFrequenciesFilterOptions';
  bool_filters: Array<Scalars['String']>;
  num_filters: Array<Scalars['String']>;
  string_filters: Array<Scalars['String']>;
};

export type VariantInfoFilterOptions = {
  __typename?: 'VariantInfoFilterOptions';
  bool_filters: Array<InfoBoolFilterOptions>;
  num_filters: Array<InfoNumFilterOptions>;
  string_filters: Array<InfoStringFilterOptions>;
};

//FIXME temp type
export type Job = any
